import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteControlHistoryModel } from '../models'

export class GetSiteControlHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/getSiteControlHistory',
      requesterInfo,
    })
  }

  public async getSiteControlHistory(): Promise<ISiteControlHistoryModel[]> {
    return await this.getAsync<ISiteControlHistoryModel[]>()
  }
}
